import React, { useState, useEffect } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import Lang from 'libraries/Lang';
import { getTopTrendsData } from 'libraries/trendsData';
import DestinationSectionLoader from './destinationSectionLoader';

const TopHotelsTgPackages = (prop) => {
    const [topHotelsTgPkgs, setHotelsTgPkgs] = useState(false);
    const [topItems, setTopItems] = useState([]);
    const [activeTitle, setActiveTitle] = useState({"tghotels" : "active", "attractions" : "", "tgpackages" : ""});
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getTopHotelsTgPkgsPromise = getTopTrendsData('/api/trends/topSearchedHotelsTgDests?env=test', prop.env, prop.start, prop.end);

        getTopHotelsTgPkgsPromise.then((result) => {
            setIsLoading(false);
            if (result.isDataAvailable !== undefined && result.isDataAvailable == true) {
                setIsDataAvailable(true);
                setHotelsTgPkgs(result);
                setTopItems(result.hotels);
            }
        });
    }, []);

    const showHotels = () => {
        setActiveTitle({"tghotels" : "active", "attractions" : "", "tgpackages" : ""});
        setTopItems(topHotelsTgPkgs.hotels);
    };

    const showAttractions = () => {
        setActiveTitle({"tghotels" : "", "attractions" : "active", "tgpackages" : ""});
        setTopItems(topHotelsTgPkgs.attractionHotels);
    };

    const showTgPackages = () => {
        setActiveTitle({"tghotels" : "", "attractions" : "", "tgpackages" : "active"});
        setTopItems(topHotelsTgPkgs.tgDestinations);
    };

    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';

    return (
        <>
            { isLoading == false ?   
                <>
                    { isDataAvailable !== false ?
                        <div className="p-5 mx-sm-5">
                            <div className="container mb-2 pb-1">
                                <h4 className="font-weight-bold">{Lang.trans('trends_top_hotels_tgdests.title')}</h4>
                                <p className="font-sm font-weight-600 text-black mb-0">{Lang.trans('trends_top_hotels_tgdests.title_description')}</p>

                                <nav className="mt-3 text-left list-unstyled nav-tabs tabs-pill-bg d-inline-flex rounded-pill mb-3" role="tablist">
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.tghotels}`} id="tg-hotels" data-toggle="tab" role="tab" aria-controls="hotels" aria-selected="true" onClick={showHotels}>
                                            {Lang.trans('trends_top_hotels_tgdests.hotels')}
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.attractions}`} id="attractions" data-toggle="tab" role="tab" aria-controls="attractions" aria-selected="true" onClick={showAttractions}>
                                            Attractions
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.tgpackages}`} id="tg-packages" data-toggle="tab" role="tab" aria-controls="tg-packages" aria-selected="true" onClick={showTgPackages}>
                                            {Lang.trans('trends_top_hotels_tgdests.tgpackages')}
                                        </a>
                                    </li>
                                </nav>

                                <div className="tab-content" id="top-travelbrands">
                                    <div className="tab-pane fade show active" id="topHotels" role="tabpanel" aria-labelledby="sub-tab">
                                        { topHotelsTgPkgs ? 
                                            <>
                                                { topItems !== undefined && topItems !== null && topItems.length > 0 ?
                                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mb-3 gutter-0">
                                                        {topItems.map((item, key) => {
                                                            const currentImgNo = key + 1;
                                                            if(item.name != undefined ) {
                                                                return (
                                                                    <div className="col-sm-6 col-xl col-lg-4 col-md-4 mb-3">
                                                                        <div className="rounded-sm box-shadow-md p-2 position-relative mx-1">
                                                                            <span className="counter-circle-list rounded-circle left top position-absolute z-index-1 font-weight-bold">
                                                                                {currentImgNo}
                                                                            </span>
                                                                            <button className="btn-unstyled deal-list-card text-decoration-none" style={{cursor: "default"}}>
                                                                                <div className="position-relative w-100 overflow-hidden">
                                                                                    <img
                                                                                        className="w-100 object-fit-cover rounded-4"
                                                                                        height="165"
                                                                                        src={(item.image != undefined && item.image != '') ? item.image : defaultImage}
                                                                                        data-was-processed="true"
                                                                                        onError={(e) => {
                                                                                            e.target.src = defaultImage;
                                                                                        }}
                                                                                    />
                                                                                    <div className="pt-4 pb-3 text-left">
                                                                                        <h6 className="font-weight-600 mb-0 font-size-sm">{item.name}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }  
                                                        })}
                                                    </div>
                                                : null }
                                            </>
                                            : <DestinationSectionLoader />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null }
                </>
            : <DestinationSectionLoader />}
        </>
    );
};

export default TopHotelsTgPackages;
